import { render, staticRenderFns } from "./wtjd.vue?vue&type=template&id=4dda8c08&scoped=true"
import script from "./wtjd.vue?vue&type=script&lang=js"
export * from "./wtjd.vue?vue&type=script&lang=js"
import style0 from "./wtjd.vue?vue&type=style&index=0&id=4dda8c08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda8c08",
  null
  
)

export default component.exports